import React from 'react';
import EDBox from '../../../../../../BaseComponents/EDBox/EDBox';
import EDSkeleton from '../../../../../../BaseComponents/Skeleton/EDSkeleton';

interface IStatistikSkeletonLoaderProps {
  count: number;
}

export const StatistikSkeletonLoader: React.FC<
  IStatistikSkeletonLoaderProps
> = ({ count }) => (
  <EDBox>
    {Array.from({ length: count }, (_, i) => (
      <EDBox key={i}>
        <EDSkeleton animation="pulse" height={'50px'} />
      </EDBox>
    ))}
  </EDBox>
);
